import React from 'react';
import { Col, ContactPerson, Divider, Row } from 'components';
import { ContactInfo } from 'feature';
import { Address } from 'feature/clientTabs/general/address';
import styles from './styles.module.scss';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const General = React.memo(() => {
  const { hasAccess } = useAccessControl();
  return (
    <Row wrap={false} className={styles.general}>
      <Col flex={'566px'}>
        <Row gutter={[0, 32]}>
          <Col span={24}>
            <HasAccess role={PERMISSIONS.clients.contact_info.read}>
              <ContactInfo />
            </HasAccess>
          </Col>
          <Col span={24}>
            <HasAccess role={PERMISSIONS.clients.contact_person.read}>
              <ContactPerson
                hasAccessToWrite={hasAccess(PERMISSIONS.clients.contact_person.write)}
                hasAccessToDelete={hasAccess(PERMISSIONS.clients.contact_person.delete)}
                entityName={'CLIENT'}
              />
            </HasAccess>
          </Col>
        </Row>
      </Col>
      <Divider className={styles.divider} type={'vertical'} />
      <Col flex={'329px'}>
        <HasAccess role={PERMISSIONS.clients.address.read}>
          <Address />
        </HasAccess>
      </Col>
    </Row>
  );
});
